import React from 'react'
import { connect } from 'react-redux'
import './homepage.css'
import OpenDates from '../components/openDates'
import headerImage from '../img/online_admision.png'
import FAQ from '../download/faq.pdf'
import exam from '../assests/pdf/Govt order for Bipard exam.pdf'
import syllabus from '../assests/pdf/Syllabus for Computer Competency Test Examination.pdf'
import gaz1 from '../assests/pdf/gaz1.pdf'
import gaz2 from '../assests/pdf/gaz2.pdf'
import gaz3 from '../assests/pdf/gaz3.pdf'
import gaz4 from '../assests/pdf/gaz4.pdf'
import p1 from '../assests/image/p1.png'
import p2 from '../assests/image/p2.png'
import p3 from '../assests/image/p3.png'
import p4 from '../assests/image/p4.png'



const HomePage = (props) => {
  return (
    <section>
      <div className='container-fluid homepage_layout'>
        <div className='right_section'>
          {/* <img className='image_department' src={headerImage} alt='departmental examination portal' /> */}
          {/* Was four separate <h3>s reading "Departmental Examination Test /
              Examination / Portal / For All Government Employees" — the word
              "Examination" appeared twice and the phrase was split across
              lines that did not form a sentence. Now one heading with a
              subtitle, styled in CSS rather than four inline style objects. */}
          <div className='page_title'>
            <h1 className='page_title_main'>
              Departmental Examination <span className='page_title_accent'>Portal</span>
            </h1>
            <p className='page_title_sub'>For all Government of Bihar employees</p>
          </div>
          <div className='button_links' >
            <div className='icon_button' title='Question Bank'>
              {/* <a href="/subject-page" target='_blank' > */}
              <a href="/subject-page" >
                <img className='icon-home' src={p1} />
                <span>Question Bank</span>
              </a>
            </div>
            <div className='icon_button' title='Exam Syllabus' >
              <a href='#' data-bs-toggle="modal" data-bs-target="#exampleModal">
                <img className='icon-home' src={p2} alt='question_bank_icon' />
                <span>Exam Syllabus</span>
              </a>
            </div>
            {/* <div className='icon_button' title='Feedback'>
              <a href="#">
                <img src='https://borexam.bihar.gov.in/upload/image/feedback_icon.png' alt='question_bank_icon' />
                <span>Feedback</span>
              </a>
            </div> */}
            {/* <div className='icon_button' title='FAQ'>
              <a href={FAQ} target='_blank' rel="noreferrer">
                <img src='https://borexam.bihar.gov.in/upload/image/faq_icon.png' alt='question_bank_icon' />
                <span>&nbsp;&nbsp;&nbsp; FAQ</span>
              </a>
            </div> */}
            <div className='icon_button' title='Practice Test'>
              <a href="https://mockbor.codebuckets.in" rel="noopener noreferrer" target='_blank'>
                <img className='icon-home' src={p3} />
                <span>Practice Test</span>
              </a>
            </div>
            <div className='icon_button' title='Verification'>
              <a href="/certificate-check" target='_blank'>
                <img className='icon-home' src={p4} />
                <span>Verification</span>
              </a>
            </div>

          </div>

          <OpenDates />

        </div>
        <div className='left_section'>
          <div className="col-sm-12 col-xs-6" >
            <div className="scrollbox" tabIndex="0">


              <div className="scrollbox-content" style={{ padding: 6, paddingLeft: 23 }}>
                <h3 style={{ color: "#00f6ff" }}>Chairman's Message</h3>
                <p style={{ color: '#fff' }}>
                  राज्य सरकार के पदाधिकारियों एवं कर्मियों को विभागीय परीक्षा में उत्तीर्ण होना अनिवार्य है। विभागीय परीक्षाओं का मुख्य उदेश्य है कि राज्य सरकार के पदाधिकारी /कर्मी को विभागीय नियमों / अधिनियमों एवं दिशा-निर्देश की जानकारी हो। इस हेतु राजस्व पर्षद द्वारा विभागीय परीक्षा का आयोजन किया जाता है। जो पदाधिकारी एवं कर्मी विभागीय परीक्षा समय पर उत्तीर्ण नहीं हो पाते हैं उन्हें नियमित वेतन वृद्धि से वंचित होना पडता है तथा कतिपय मामलों में उनके प्रोन्नति पर भी इसका असर होता है।
                </p>
                <p style={{ color: '#fff' }}>
                  राज्य सरकार के पदाधिकारियों एवं कर्मियो की सुविधा एवं परीक्षा की पारदर्शी व्यवस्था के लिए 15 जून 2018 से ऑनलाईन विभागीय परीक्षा का आयोजन हो रहा है। प्रारम्भ में यह परीक्षा सचिवालय स्थित परीक्षा केन्द्र पर ली जाती थी। वर्तमान में बिपार्ड के पटना एवं गया परीक्षा केन्द्र पर विभागीय परीक्षा का आयोजन हो रहा है।
                </p>
                <p style={{ color: '#fff' }}>
                  ऑनलाईन विभागीय परीक्षा व्यवस्था के फलस्वरूप परीक्षा के सात दिनों के अन्दर सफल पदाधिकारियों को विभागीय परीक्षा उत्तीर्णता प्रमाण-पत्र <strong>(Certificate)</strong> राजस्व पर्षद के विभागीय बेवसाईट पर अपलोड किया जा रहा है। राज्य सरकार के पदाधिकारी एवं कर्मी राजस्व पर्षद के बेवसाईट से अपना उत्तीर्णता प्रमाण-पत्र डाउनलोड कर सकते हैं। परीक्षार्थी अपने मूल <strong>Certificate</strong>  को राजस्व पर्षद कार्यालय से भी प्राप्त कर सकते हैं। मुझे खुशी है कि पिछले पाँच वर्ष से अधिक समय से यह व्यवस्था सफलतापूर्वक संचालित हो रहा है।
                </p>

                <p style={{ color: '#fff' }}>
                  राजस्व पर्षद द्वारा वर्तमान में 73 सेवा संवर्ग के राजपत्रित / अराजपत्रित पदाधिकारियों /कर्मियों के लिए कुल 35 विषयों की ऑनलाईन (कम्प्यूटरीकृत) विभागीय परीक्षा आयोजित की जा रही है।
                </p>
                <p style={{ color: '#fff' }}>
                  विभागीय परीक्षा में सम्मिलित होने हेतु परीक्षार्थी Board of Revenue के बेवसाईट पर पंजीकरण कर सकते हैं। राज्य सरकार के कर्मी राजस्व पर्षद के विभागीय परीक्षा पोर्टल पर <a href="https://borexam.bihar.gov.in/" target="_blank" style={{ color: '#f6852a' }}>borexam.bihar.gov.in</a>  लॉगिन कर अपनी सुविधानुसार संबंधित विषयों की परीक्षा हेतु तिथि एवं समय का चयन स्वयं कर सकते हैं।
                </p>
                <p style={{ color: '#fff' }}>
                  परीक्षार्थियों की सुविधा के लिए विभिन्न विषयों का प्रश्न अधिकोष राजस्व पर्षद के विभागीय परीक्षा पोर्टल पर अपलोड किया गया है जिसमें पाठयक्रम के अनुरूप पर्याप्त वस्तुनिष्ठ <strong>(Objective)</strong>  प्रश्न समाहित हैं। प्रश्न अधिकोष के अवलोकन हेतु परीक्षार्थी राजस्व पर्षद के परीक्षा पोर्टल के Question Bank पर जा सकते हैं। उक्त प्रश्न अधिकोष का <a href="https://borexam.bihar.gov.in/" target="_blank" style={{ color: '#f6852a' }}>borexam.bihar.gov.in</a>  अध्ययन कर परीक्षार्थियों के लिए विभागीय परीक्षा में उत्तीर्णता प्राप्त करने की प्रक्रिया सुगम हो गया है।
                </p>
                <p style={{ color: '#fff' }}>

                  परीक्षा के संबंध में कोई परेशानी / समस्या के समाधान हेतु Board of Revenue के Helpline No.-0612-2217848 एवं Bipard के Helpline No.-0612-2452018 पर संपर्क किया जा सकता है।
                </p>
                <p style={{ color: '#fff' }}>
                  विभागीय परीक्षा के आयोजन के चरम उद्देश्य की प्राप्ति के लिए आवश्यक है कि प्रश्न अधिकोष को लगातार परिवर्द्धित किया जाय तथा पदाधिकारी एवं कर्मियों से फिडबैक प्राप्त कर इसमें लगातार आवश्यक सुधार किया जाय। समय-समय पर विषयों एवं इसके सिलेबस को भी संशोधित करने की आवश्यकता होगी। राज्य सरकार के पदाधिकारी /कर्मी अपना फीडबैक राजस्व पर्षद के हेल्पलाईन नम्बर पर दे सकते हैं साथ ही राजस्व पर्षद के ईमेल में भी अपना फीडबैक दे सकते हैं।
                </p>
                {/* <p style={{ color: '#fff' }}>&nbsp;&nbsp;&nbsp;&nbsp;मुझे आपको यह सूचित करते हुए अपार हर्ष महसूस हो रहा है कि राजस्व पर्षद द्वारा अब सभी विभागीय परीक्षाएँ कम्प्यूटरीकृत प्रणाली द्वारा ली जाएगी। इस हेतु विभागीय परीक्षा Portal बनाया गया है जिस पर मेरा यह संदेश आप देख पा रहे है।</p>
                <p style={{ color: '#fff' }}>&nbsp;&nbsp;&nbsp;&nbsp;मैं यह भी उल्लेख करना चाहूँगा कि कम्प्यूटरीकृत विभागीय परीक्षा की तैयारी पर्षद लगभग डेढ़ वर्ष से कर रहा है। इस क्रम में सबसे पहले विभागीय परीक्षाओं के पाठ्यक्रम को बदला गया और जहाँ पुराने अधिनियम/नियम को हटाया गया, वहीं नए प्रख्यापित नियम/अधिनियम को भी डाला गया। पाठ्यक्रम में एकरूपता लाई गई एवं पुस्तक रहित विषयों को भी समाप्त किया गया। इससे यह लाभ हुआ कि जहाँ पहले पर्षद को सभी सेवाओं हेतु 105 प्रश्न पत्र तय करने पड़ते थे, वहाँ अब यह मात्र 25 रह गये हैं। पहले इन 105 प्रश्न पत्रों को बनाने, छपवाने एवं इनका परीक्षाफल घोषित करने में बहुत समय लग जाता था और परीक्षार्थियों को काफी प्रतीक्षा करनी पड़ती थी। यह सुधार इसलिए किया गया ताकि कम्प्यूटरीकृत माध्यम से परीक्षा ली जा सके और परिणाम भी तुरंत घोषित हो सके। नए रूप से पाठ्यक्रम को तय कर उसकी विधिवत अधिसूचना भी जारी की गई है, जिसे <a href="https://bor-user.codebucketstage.online/" target="_blank" style={{ color: '#f6852a' }}>अधिसूचना</a> पर देखा जा सकता है।</p> */}
                {/* <p style={{ color: '#fff' }}>इस नई व्यवस्था से आपको निम्नलिखित लाभ होंगे:-
                </p><ol style={{ color: '#fff' }}>
                  <li>यह प्रणाली परीक्षार्थियों के लिए काफी लाभकारी होगी। आगामी जून 2018 से कोई भी राजपत्रित अथवा अराजपत्रित कर्मी अब सारे वर्ष किसी भी समय अपनी सुविधानुसार तथा तैयारी को देखते हुए परीक्षा दे सकते हैं । पंजीकरण की तिथि के 15 दिनों से आगे अगले तीन महीनों के भीतर, परीक्षा की तिथि का Slot Booking, आप स्वयं कर सकते हैं ।</li>
                  <li>आप Portal पर <a href="https://bor-user.codebucketstage.online/login" target="_blank" style={{ color: '#f6852a' }}>log in </a>करके अपनी सुविधानुसार संबंधित विषयों में परीक्षा देने हेतू अपनी तिथि एवं समय स्वयं चुन सकते हैं । परीक्षा हेतु पंजीकरण करने के लिए आप इस <a href="http://boardofrevenue.bih.nic.in/" target="_blank" style={{ color: '#f6852a' }}>Board of Revenue Website</a> पर जा सकते हैं । पंजीकरण के समय कोई परेशानी होने पर हेल्पलाइन 0612-2217848 पर संपर्क किया जा सकता है।</li>
                  <li>आपकी तथा आपके नियंत्री पदाधिकारी की सुविधा को देखते हुए आप विभागीय परीक्षाएं शनिवार और अन्य अवकाशीय दिवसों में भी दे सकते हैं।</li>
                  <li>चूँकि परीक्षा कम्प्यूटर के माध्यम से होगी, अतः सारी परीक्षाएं मुख्य सचिवालय में राजस्व पर्षद, पटना स्थित परीक्षा हॉल में होगी।</li>
                </ol>
                <p></p>
                <p style={{ color: '#fff' }}>&nbsp;&nbsp;&nbsp;&nbsp;विभागीय परीक्षाओं का मुख्य उद्देश्य यह देखना है कि संबंधित कर्मी को विभागीय नियमों/अधिनियमों एवं दिशा निर्देश की जानकारी हो, अतः परीक्षा में पूछे जाने वाले सभी विषयों के प्रश्न अधिकोष इस Portal पर अभी से ही डाले जा रहे हैं ताकि आप इन्हें पढ़े और सही उत्तर ( जो कि प्रश्न अधिकोष में ही दिए गए है ) देख सकें। इसी प्रश्न अधिकोष से ही कोई 100 प्रश्न Random आधार पर आपसे परीक्षा के दिन पूछे जायेंगे। यह Randomization कम्प्यूटर द्वारा Software के माध्यम से किया जायेगा।</p>
                <p style={{ color: '#fff' }}>&nbsp;&nbsp;&nbsp;&nbsp;अतः इस प्रश्न अधिकोष को आपके फायदे के लिए Portal पर डाला जा रहा है ताकि आप परीक्षा से पहले कुछ दिनों तक इन प्रश्नों को अच्छी तरह पढ़ लें एवं समझ लें। प्रश्न अधिकोष हेतु आप इस <a href="https://borexam.bihar.gov.in/borexam/esexam_report/question_bank_search.php" style={{ color: '#f6852a' }} target="_blank">Question Bank</a> पर जा सकते है।</p>
                <p style={{ color: '#fff' }}>&nbsp;&nbsp;&nbsp;&nbsp;आप हमारे Examination Hall मे अपने लैपटॉप से भी Exam दे सकते हैं ।</p>
                <p style={{ color: '#fff' }}>&nbsp;&nbsp;&nbsp;&nbsp;    मेरा यह भी अनुरोध होगा कि इस प्रश्न अधिकोष को देख कर आप इस सबंध में अपना Feedback इस email ID - borexam(at)bihar(dot)gov(dot)in पर भेजें। यदि किसी प्रश्न पर या प्रश्न के उत्तर पर आपकी कोई भिन्न राय है तो उससे भी हमें अवगत करायें। विभागीय परीक्षाओं को और बेहतर करने तथा <a href="https://borexam.bihar.gov.in/borexam/esexam_report/question_bank_search.php" style={{ color: '#f6852a' }} target="_blank">Question Bank</a> की गुणवत्ता को और सुधारने के लिए आपके सुझावों का हमेशा स्वागत रहेगा।</p> */}
                <p style={{ color: '#fff' }}>&nbsp;&nbsp;&nbsp;&nbsp;शुभकामनाओं के साथ। </p><div className="pull-right" style={{ color: '#fff' }}>( श्रीमती हरजोत कौर बम्हरा )<br />अध्यक्ष सह सदस्य,
                  <br />राजस्व पर्षद, बिहार, पटना।</div><p></p>
              </div>




            </div>
          </div>
        </div>
      </div>

      {/* modal */}
      <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Gazette List</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <table className="table table-bordered border-primary">
                <thead style={{ backgroundColor: '#496CAD', color: 'white' }}>
                  <tr>
                    <th scope="col">Sl No.</th>
                    <th scope="col">Gazette Name</th>
                    <th scope="col">Published Date</th>
                    <th scope="col">PDF</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>BoR Gazette 1</td>
                    <td>02-01-2018</td>
                    <td><a href={gaz1} target="_blank"><i className='fa fa-download'></i></a> </td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>BoR Gazette 2</td>
                    <td>29-05-2018</td>
                    <td><a href={gaz2} target="_blank"><i className='fa fa-download'></i></a> </td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>BoR Gazette 3</td>
                    <td>05-11-2018</td>
                    <td><a href={gaz3} target="_blank"><i className='fa fa-download'></i></a> </td>
                  </tr>
                  <tr>
                    <th scope="row">4</th>
                    <td>BoR Gazette 4</td>
                    <td>18-03-2019</td>
                    <td><a href={gaz4} target="_blank"><i className='fa fa-download'></i></a> </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </section >
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.Auth
  }
}

export default connect(mapStateToProps)(HomePage)